enum TimeUnit {
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousQuarter = 'PREVIOUS_QUARTER',
  PreviousYear = 'PREVIOUS_YEAR',
}

export default TimeUnit;
